import React from 'react';
import Chart from 'react-apexcharts';

const ViewsBarChart = ({ data, color }) => {
  const chartData = {
    series: [{
      name: 'Views',
      data: data.map(item => item.views)
    }],
    options: {
      chart: {
        type: 'bar',
        height: 150,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%',
        },
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: data.map(item => item.date),
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      grid: {
        show: false
      },
      tooltip: {
        enabled: true
      },
      colors: [color]
    }
  };

  return (
    <div style={{ height: '150px' }}>
      <Chart options={chartData.options} series={chartData.series} type="bar" height="100%" />
    </div>
  );
};

export default ViewsBarChart;